<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>用户分组</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="position: static;float: left">
        <el-input
            placeholder="请输入分组，邮箱"
            clearable
            v-model="queryData.search"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>

        <el-button
            type="primary"
            @click="handleSearch"
        >搜索
        </el-button>
        <el-button
            type=""
            @click="resetSearch"
        >重置
        </el-button>

      </div>
      <div class="preview-opration" style="float: right;;right: 0px; white-space:nowrap">
        <el-button style="margin-right: 30px" icon="el-icon-plus" type="primary" @click="openCreateTaskDialog">
          添加股东用户分组
        </el-button>
      </div>
      <el-table :data="dataList">
        <el-table-column prop="name" label="用户分组"></el-table-column>
        <el-table-column prop="userCnt" label="关联账户"/>
        <el-table-column label="类型">
          <template slot-scope="scope">
            {{ scope.row.type == 0 ? "普通用户" : "股东用户" }}
          </template>
        </el-table-column>
        <el-table-column prop="email" label="绑定邮箱"/>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{ scope.row.updateTime | moment }}
          </template>
        </el-table-column>
        <el-table-column prop="notes" label="备注"/>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!--            <el-button type="" v-show="scope.row.type!=0" icon="el-icon-show" @click="seeTaskData(scope.row)">查看-->
            <!--            </el-button>-->
            <el-button type="primary" v-if="scope.row.type==0" disabled icon="el-icon-edit"
                       @click="handleEdit(scope.row)">编辑
            </el-button>
            <el-button type="primary" v-if="scope.row.type!=0"  icon="el-icon-edit"
                       @click="handleEdit(scope.row)">编辑
            </el-button>
            <el-button type="primary" icon=""
                       @click="handleShow(scope.row)">查看
            </el-button>
          </template>
        </el-table-column>

      </el-table>

      <pagination
        :total="total"
        :page.sync="queryData.page"
        :limit.sync="queryData.size"
        @pagination="getList" @pageChanged="changePage" />
    </el-card>

    <el-dialog title="添加股东用户分组" :visible.sync="dialogVisible" width="40%" @close="getList"
               :close-on-click-modal="false">
      <div>
        <div style="margin-top: 20px">
          <span style="padding-right: 20px;">
            <i style="color: #f56c6c;margin-right: 1px;">*</i>
            分组名称</span>
          <el-input maxlength="30" style="width: 70%" size="small" v-model="saveData.name"></el-input>
        </div>
        <div style="margin-top: 20px">
          <span style="padding-right: 20px">
            <i style="color: #f56c6c;margin-right: 1px;">*</i>
            绑定邮箱</span>
          <el-input style="width: 70%" size="small" placeholder="请输入内容" type="email"
                    v-model="saveData.email">
          </el-input>
        </div>
        <div style="margin-top: 20px">
          <span style="padding-right: 50px">
            <i style="color: #f56c6c;margin-right: 1px;">&nbsp;</i>
            备注</span>
          <el-input style="width: 70%" size="small" placeholder="请输入内容"
                    v-model="saveData.notes">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="createTask">确 定</el-button>
            </span>
    </el-dialog>


    <el-dialog title="编辑股东用户分组" :visible.sync="dialogVisibleEdit" width="40%" @close="getList"
               :close-on-click-modal="false">
      <div>
        <div style="margin-top: 20px">
          <span style="padding-right: 20px;">
            <i style="color: #f56c6c;margin-right: 1px;">*</i>
            分组名称</span>
          <el-input maxlength="30" style="width: 70%" size="small" v-model="editData.name"></el-input>
        </div>
        <div style="margin-top: 20px">
          <span style="padding-right: 20px">
            <i style="color: #f56c6c;margin-right: 1px;">*</i>
            绑定邮箱</span>
          <el-input style="width: 70%" size="small" placeholder="请输入内容" type="email"
                    v-model="editData.email">
          </el-input>
        </div>
        <div style="margin-top: 20px">
          <span style="padding-right: 50px">
            <i style="color: #f56c6c;margin-right: 1px;">&nbsp;</i>
            备注</span>
          <el-input style="width: 70%" size="small" placeholder="请输入内容"
                    v-model="editData.notes">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="updateTask">确 定</el-button>
            </span>
    </el-dialog>


    <el-dialog title="分组详情" :visible.sync="dialogVisibleShow" width="60%" @close="getList"
               :close-on-click-modal="false">
      <template slot="title">
        <span style="padding-right: 28px; font-size: 18px;">分组详情</span>
        <el-button type="primary" icon="el-icon-plus" style="float: right; margin-top: 120px; margin-right: 40px;" @click="openAddUserDialog">添加用户</el-button>
      </template>
      <div>
        <div style="margin-top: 20px">
          <div style="float: left">
             <span style="padding-right: 20px;">
            用户标签</span>
            <sapn>{{showInfo.name}}</sapn>
          </div>
          <div style="float: left;left: 100px;margin-left: 100px;">
     <span style="padding-right: 20px;">
            关联账户</span>
            <sapn>{{showInfo.userCnt}}</sapn>
          </div>
          <div style="">&nbsp;</div>
        </div>

        <div style="margin-top: 20px">
            <span style="padding-right: 20px;">
            绑定邮箱</span>
          <sapn>{{showInfo.email}}</sapn>
        </div>
        <div style="margin-top: 20px">
            <span style="padding-right: 20px;">
            备注</span>
          <sapn>{{showInfo.notes}}</sapn>
        </div>
      </div>
      <el-table :data="dataListUser.records" ref="multipleTable" >
        <el-table-column  label="序号">
          <template slot-scope="scope">
            {{ getNum(scope.$index+1)}}
          </template>
        </el-table-column>
        <el-table-column prop="id" label="用户ID"></el-table-column>
        <el-table-column prop="email" label="登录账户"/>
        <el-table-column prop="content" label="绑定邮箱">
          <template slot-scope="scope">
            {{ scope.row.emailGroupId === 1 || scope.row.emailGroupId === null ? "" : showInfo.email }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="danger" icon="el-icon-delete"
                       @click="handleRemoveUser(scope.row)">移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="queryData2.pageSize"
                     :current-page.sync="queryCondition.pageNo" @current-change="changePage2"/>
    </el-dialog>

    <el-dialog title="添加用户" :visible.sync="addUserDialogVisible" width="40%" append-to-body>
      <div>
        <div style="margin-top: 20px">
          <span style="padding-right: 20px;">
            <i style="color: #f56c6c;margin-right: 1px;">*</i>
            邮箱账号</span>
          <el-input style="width: 70%" size="small" placeholder="请输入内容" type="email"
                    v-model="addUserData.email">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddUser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from './api'
import Pagination from 'components/pagination'

export default {
  name: 'emailGroup',
  components: {
    Pagination
  },
  data() {
    return {
      account: '',
      dataList: [],
      dialogVisible: false,
      dialogVisibleEdit: false,
      dialogVisibleShow: false,
      dataListUser:[],
      showInfo: {
        email: ''
      },
      taskData: {},
      total: 0,
      queryCondition:{
        pageNo:1
      },
      queryData: {
        search: '',
        page: 1,
        size: 100
      },
      queryData2: {
        pageNum: 1,
        pageSize: 10,
        queryValue: "",
        queryType: "",
        groupId: "",
        groupType: ""
      },
      saveData: {
        name: "",
        email: "",
        notes: ""
      },
      editData: {
        id: 0,
        name: "",
        email: "",
        notes: ""
      },
      addUserDialogVisible: false,
      addUserData: {
        email: ''
      }
    };
  },
  methods: {
    getList() {
      this.trimQuery();
      api.groupList(this.queryData).then(res => {
        console.log(res)
        this.dataList = res.data.records || res.data;
        this.total = res.data.total || res.data.length;
      })
    },
    handleSearch() {
      this.getList();
    },
    changePage(pagination) {
      this.queryData.page = pagination.page;
      this.queryData.size = pagination.size;
      api.groupList(this.queryData).then(res => {
        this.dataList = res.data.records || res.data;
        this.total = res.data.total || res.data.length;
      })
    },
    changePage2(val){
      this.queryData.pageNum = val;
      this.queryData2.pageNum=val;
      api.getUsers(this.queryData2).then(res => {
        console.log(res)
        this.dataListUser = res.data;
        this.total = res.data.total;
      })
    },
    resetSearch() {
      this.queryData.search = "";
      this.getList();
    },
    clearData() {
      // this.$refs['upload'].clearFiles();
      // this.failList = [];
      // this.taskData = {emailTheme: '', emailContent: ''};
    },
    createTask() {

      if (!this.saveData.name) {
        this.$message.error('分组名称不能为空！');
        return;
      }
      let nameExist = false;
      this.dataList.forEach(i => {
        if (i.name === this.saveData.name) {
          nameExist = true;
        }
      })

      if (nameExist) {
        this.$message.error('分组名称已存在！');
        return;
      }

      let reg = /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/

      if (!this.saveData.email || !reg.test(this.saveData.email)) {
        this.$message.error('邮箱格式不正确！');
        return;
      }

      api.save(this.saveData).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.saveData.notes = "";
          this.saveData.email = "";
          this.saveData.name = "";
          this.$message.success('操作成功！');
          this.dialogVisible = false;
        } else {
          this.$message.error('操作失败！');
        }
      })
    },
    openCreateTaskDialog() {
      this.dialogVisible = true;
    },
    handleEdit(data) {
      this.dialogVisibleEdit = true;
      this.editData.id = data.id;
      this.editData.name = data.name;
      this.editData.email = data.email;
      this.editData.notes = data.notes;
    },
    handleShow(rowdata) {
      this.queryData2.pageNum=1;
      this.dialogVisibleShow = true;
      this.showInfo=rowdata;
      this.queryData2.groupId=rowdata.id;
      api.getUsers(this.queryData2).then(res => {
        console.log(res)
        this.dataListUser = res.data;
        this.total = res.data.total;
      })
    },
    getNum(index){
      return (this.queryData2.pageNum-1)*this.queryData2.pageSize + index;
    },
    updateTask() {
      if (!this.editData.name) {
        this.$message.error('分组名称不能为空！');
        return;
      }
      let nameExistCnt = 0;
      this.dataList.forEach(i => {
        if (i.id !== this.editData.id && i.name === this.editData.name) {
          nameExistCnt++
        }
      })

      if (nameExistCnt > 0) {
        this.$message.error('分组名称已存在！');
        return;
      }

      let reg = /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/

      if (!this.editData.email || !reg.test(this.editData.email)) {
        this.$message.error('邮箱格式不正确！');
        return;
      }

      api.update(this.editData).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.editData.notes = "";
          this.editData.email = "";
          this.editData.name = "";
          this.$message.success('操作成功！');
          this.dialogVisibleEdit = false;
        } else {
          this.$message.error('操作失败！');
        }
      })
    },
    handleRemoveUser(row) {
      this.$confirm('确定要从该分组中移除该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.removeUser({"emailGroupId": row.emailGroupId, "id": row.id});
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消移除'
        });
      });

    },
    trimQuery() {
      this.queryData.search = this.queryData.search.replace(/(^\s*)|(\s*$)/g, '')
    },
    openAddUserDialog() {
      this.addUserData.email = '';
      this.addUserDialogVisible = true;
    },
    handleAddUser() {
      if (!this.addUserData.email) {
        this.$message.error('邮箱账号不能为空！');
        return;
      }

      let reg = /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/

      if (!reg.test(this.addUserData.email)) {
        this.$message.error('邮箱格式不正确！');
        return;
      }

      api.addUser({ emailGroupId: this.showInfo.id, email: this.addUserData.email }).then(res => {
        if (res.code === 0) {
          this.$message.success('添加成功！');
          this.addUserDialogVisible = false;
          this.addUserData.email = '';
          this.handleShow(this.showInfo); // 刷新用户列表
        } else {
          this.$message.error('添加失败！');
        }
      });
    }
  },
  created() {
    this.getList();
  }
}
</script>
